// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sqae3","requiredAsterisk":"Info_requiredAsterisk__153B2"};